"use strict";

Shopify.theme.jsPreLaunchChecklist  = {

    init: function init($section) {
      this.$section  = $section
      Shopify.theme.jsPreLaunchChecklist = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
      this.setPreSelectTypes()
      this.initTimeline($section)
    },
    setPreSelectTypes: function setPreSelectTypes($section){
        let $inputs = this.$section.find('[data-checklist-item]')
        //set change listener
        $inputs.on('change',this.updatePreSelectTypes.bind(this))
        
        let checkedItems = localStorage.getItem('pre-launch-checklist')
        if(!checkedItems){
//         	console.log('No Pre Selections')
            return;
        }
        
        $inputs.each(function(index,item){
          if(checkedItems.indexOf($(item).data('type'))>-1){
          	$(item).prop('checked',true)
          }
        }.bind(this))
    },
    updatePreSelectTypes: function updatePreSelectTypes($section){
        let checkedList = []
    	let $inputs = this.$section.find('[data-checklist-item]')
        $inputs.each(function(index,item){
          if($(item).is(':checked:not([disabled])')){
          	checkedList.push($(item).data('type'))
          }
        }.bind(this))
       localStorage.setItem('pre-launch-checklist',checkedList)
    },
    resetTop: function resetTop() {
        $section.find(".timeline--item a").css('top', 0)
    },
    navList: function navList($section) {
        let navlist = []
        if (!$section) {
            return []
        }
        $section.find(".timeline--item a").each(function(i) {
            var thisLink = $(this);
            var thisId = thisLink.attr('href');
            var thisTarget = $(thisId);
            var height = thisTarget.outerHeight()
            thisLink.parent().css('height', height+50)

            navlist.push({
                'anchor': thisLink,
                'id': thisId,
                'target': thisTarget
            });
        });
        return navlist
    },
    initTimeline: function initTimeline($section) {
        $section.find('timeline--item a').on('click', function(e) {
            let $link = $(this)
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(`#${$link.attr('href')}`).offset().top - $('#mobile-header').height()
            }, 800);
        });



        Shopify.theme.jsPreLaunchChecklist.updateHash($section)
        Shopify.theme.horizontalScrollBar.updateValues()
        $(window).on('scroll resize', function(e) {
            Shopify.theme.horizontalScrollBar.updateValues()
            Shopify.theme.jsPreLaunchChecklist.updateHash($section)
        })

        function moveAnimation() {
            Shopify.theme.horizontalScrollBar.updateValues()
            Shopify.theme.jsPreLaunchChecklist.updateHash($section)
        }


    },
    updateHash: function($section) {
        let navlist = Shopify.theme.jsPreLaunchChecklist.navList($section)
        if ($('#mobile-header').hasClass('sticky--enabled')) {
            $('.timeline .nav li a').css('top', '120px')
        } else {
            $('.timeline .nav li a').css('top', '20px')

        }
        $.each(navlist, function(e, elem) {
            var placement = elem.target[0].getBoundingClientRect();
            if (
                (placement.top - $('#mobile-header').height() < 0) &&
                (placement.top - $('#mobile-header').height() + placement.height > 0)
            ) {
                //history.pushState({}, '', elem.id);
                $section.find(".timeline--item").removeClass('active')
                $section.find(`.timeline--item [href="${elem.id}"]`).parent()
                    .addClass('active')

                return false; /* Exit $.each loop */
            } else {
                $section.find(".timeline--item").removeClass('active')
                //return false;
            }
        });
    },
    unload: function unload($section) {
        history.pushState({}, '', '')
        $section.find(".timeline--item a").off('click')
        Shopify.theme.jsPreLaunchChecklist.resetTop()
        $section.find(".timeline--item a").removeClass('active')
        Shopify.theme.jsPreLaunchChecklist.navList()

    }
}